import { Field, FieldProps } from "formik";
import React from "react";

import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  radioChildWrapper: {
    paddingLeft: "31px"
  },
  label: {
    color: theme.palette.text.primary,
    fontSize: 10.5, // matches text label input
    fontWeight: 700
  }
}));

export interface RadioOptions {
  label: string;
  value: string;
  children?: JSX.Element;
}

export default function FormikRadioField({
  label,
  name,
  options,
  value
}: {
  label: string;
  name: string;
  options: RadioOptions[];
  value: string;
}): JSX.Element {
  const classes = useStyles();

  return (
    <FormControl>
      <FormLabel className={classes.label}>{label}</FormLabel>
      <Field>
        {({ meta, form }: FieldProps) => (
          <RadioGroup
            name={name}
            defaultValue={meta.initialValue[name]}
            onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
              form.setFieldValue(name, evt.target.value)
            }
          >
            {options.map(o => (
              <React.Fragment key={`${name}-radio-${o.value}`}>
                <FormControlLabel
                  value={o.value}
                  control={<Radio />}
                  label={o.label}
                />
                {o.children && value === o.value && (
                  <div className={classes.radioChildWrapper}>{o.children}</div>
                )}
              </React.Fragment>
            ))}
          </RadioGroup>
        )}
      </Field>
    </FormControl>
  );
}
